const styles = {
    grow: {
        flex: 1
    },
    clickable: {
        cursor: "pointer"
    },
    offsetTop4: {
        marginTop: -4
    },
    offsetTop8: {
        marginTop: -8
    },
    noMinWidth: {
        minWidth: "unset"
    }
};

export default styles;
